<template>
  <div class="phy_wrap">
    <div v-show="!organDetailShow">
      <new-text :text="text"></new-text>
      <div class="phy_top">
        <div class="recordTit">
          <div class="title">平均免疫风险等级</div>
          <LevelBar class="risk-status" :active-index="list.physiology_level" />
        </div>
        <div class="nines">
          <div
            class="phy-box"
            @click="toDetails(item)"
            v-for="(item, index) in list.physiology"
            :key="item.name"
          >
            <img :src="ossUrl + '/phy-h5/' + item.name + '.png'" />
            <div class="tit">{{ item.name + (index != 8 ? "系统" : "") }}</div>
            <div class="desc">
              <img v-if="item.status" :src="handleStatusImg(item.status)" />
              <img v-else :src="handleImg(item.functional_status)" />
              {{
                item.status ? item.status : handleRist(item.functional_status)
              }}
            </div>
          </div>
        </div>
        <!-- <echarts-bar :if-click="list.physiology_system ? true : false" :barlist="list.physiology" @handle-organ="handleOrgan"></echarts-bar> -->
      </div>
      <div class="phy_cont">
        <div class="summary">{{ list.physiology[0].exam_desc }}</div>
        <div class="common_title">各生理系统常见风险</div>
        <div
          class="physiology"
          v-for="(item, index) in list.physiology"
          :key="index"
        >
          <span>{{ item.name }}常见风险：</span>
          {{ item.desc }}
        </div>
      </div>
    </div>
    <OrganDetail
      @show-dialog="showDialog"
      v-show="organDetailShow"
      :list="list.physiology_system"
      :organ-name="organName"
      @hide-details="hideDetails"
    />
  </div>
</template>
<script>
import EchartsBar from "@/components/EchartsBar";
import OrganDetail from "@/components/OrganDetail";
import SignsDialog from "@/components/SignsDialog"
import NewText from "./NewText";
import LevelBar from "./LevelBar";
import { ossUrl } from "@/config";
export default {
  props: ["list", "organShow"],
  components: { EchartsBar, NewText, LevelBar, OrganDetail },
  data () {
    return {
      ossUrl,
      showSigns: true,
      organDetailShow: false,
      organName: "",
      text: "免疫力与人体8大生理系统密切相关，风险数值0-40为最佳范围，41-60处于临界，超出60代表风险偏高，需引起重视。如果8大生理系统风险数值均超出60，通常首先关注：消化系统、呼吸系统、免疫系统，并结合自身症状咨询专业医生进行健康管理。",
    };
  },
  created () {
    this.organDetailShow = false
  },
  methods: {
    /** 判断风险等级 */
    handleImg (score) {
      let url = ''
      if (score > 0 && score <= 20) {
        url = `${this.ossUrl}/phy-h5/risk-icon1.png`
      } else if (score > 20 && score <= 40) {
        url = `${this.ossUrl}/phy-h5/risk-icon2.png`
      } else if (score > 40 && score <= 60) {
        url = `${this.ossUrl}/phy-h5/risk-icon3.png`
      } else if (score > 60 && score <= 80) {
        url = `${this.ossUrl}/phy-h5/risk-icon4.png`
      } else if (score > 80 && score <= 100) {
        url = `${this.ossUrl}/phy-h5/risk-icon5.png`
      }
      return url
    },
    handleStatusImg (txt) {
      let url = ''
      if (txt == '正常') {
        url = `${this.ossUrl}/phy-h5/risk-icon1.png`
      } else if (txt == '低风险') {
        url = `${this.ossUrl}/phy-h5/risk-icon2.png`
      } else if (txt == '偏低风险') {
        url = `${this.ossUrl}/phy-h5/risk-icon3.png`
      } else if (txt == '偏高风险') {
        url = `${this.ossUrl}/phy-h5/risk-icon4.png`
      } else if (txt == '高风险') {
        url = `${this.ossUrl}/phy-h5/risk-icon5.png`
      }
      return url
    },
    handleRist (score) {
      let txt = ''
      if (score > 0 && score <= 20) {
        txt = `正常`
      } else if (score > 20 && score <= 40) {
        txt = `低风险`
      } else if (score > 40 && score <= 60) {
        txt = `偏低风险`
      } else if (score > 60 && score <= 80) {
        txt = `偏高风险`
      } else if (score > 80 && score <= 100) {
        txt = `高风险`
      }
      return txt
    },
    toDetails (item) {
      const ifClick = this.list.physiology_system ? true : false
      if (ifClick) {
        this.handleOrgan(item.name)
      }
    },
    showDialog () {
      this.$emit('show-dialog')
    },
    /** 打开详情 */
    handleOrgan (name) {
      this.organName = name;
      this.organDetailShow = true;
    },
    /** 关闭详情 */
    hideDetails () {
      this.organDetailShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.phy_wrap {
  width: 700px;
  margin: auto;
}
.phy_top {
  width: 100%;
  background-color: #fff;
  text-align: center;
  font-size: 30px;
  min-height: 600px;
  padding-top: 30px;
  .risk_sc {
    font-size: 46px;
    color: #dd1008;
  }
  p {
    margin: 30px 0 0px;
  }
}
.phy_cont {
  padding: 40px 16px;
  background-color: #fff;
  font-size: 32px;
  color: #616161;
  line-height: 36px;
  margin: 40px 0;
  text-align: left;

  .physiology {
    padding: 10px 0;
    span {
      font-size: 32px;
      font-weight: bold;
      color: #2e94e5;
    }
  }
}
.risk-status {
  margin: 20px auto 30px;
  width: 350px;
}
.nines {
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto 0;
  width: 650px;
  > div {
    width: 156px;
    padding: 20px;
    background-color: rgba(44, 190, 139, 0.1);
    text-align: center;
    margin-right: 30px;
    margin-bottom: 30px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .tit {
      font-size: 28px;
      margin: 10px 0 20px;
      color: #4d5250;
    }
    .desc {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #848484;
      height: 36px;
      display: none;
      img {
        width: 30px;
        margin-right: 10px;
      }
    }
    > img {
      width: 100px;
    }
  }
}
</style>